/**
 * Number input component.
 * 
 * @author Darrus Goh
 */
export default function NumberInputComponent() {
    const DEFAULT_ONCHANGE = (number) => { console.log(`Number Input Component: ${number}`) };

    return {
        view: ({ attrs: { id, style, min, max, step, required, placeholder, disabled, readonly, value, onChange = DEFAULT_ONCHANGE } }) => {
            return m('div',
                m('.row',
                    m('.col-12',
                        m('input', {
                            id,
                            class: "form-control form-control-bg " + style,
                            type: "number",
                            required,
                            placeholder,
                            disabled,
                            readonly,
                            min,
                            max,
                            step,
                            value,
                            onchange: (e) => {
                                if(step && step.includes('.')) {
                                    // +1 to get the numbers after the decimal point
                                    const decimalNumberString = step.substring(step.lastIndexOf('.') + 1);
                                    onChange(parseFloat(e.target.value).toFixed(decimalNumberString.length));
                                } else {
                                    onChange(parseInt(e.target.value));
                                }
                            }
                        })
                    )
                ),
                m('.d-flex.gap-2',
                    !isNaN(min) && m('small.text-muted.font-weight-light', `Min: ${min}`),
                    !isNaN(max) && m('small.text-muted.font-weight-light', `Max: ${max}`)
                )
            )
        }
    };
}